import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    card: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    header: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    cardInfo: {
        flexDirection: "column",
        flex: 1
    },
    jumpInputContainer: {
        justifyContent: "center"
    },
    headerButtonsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    jumpContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    cardActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    jumpInput: {
        borderWidth: 1,
        height: 40,
        width: 60
    },
    createContainer: {
    },
    searchContainer: {
    },
    scrollContent: {
    },
    listContainer: {
        flex: 1
    },
    profileImage: {
        height: 40,
        width: 40
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
